// Importing React to build the component.
import React from "react";

// Importing the useState hook.
import { useState } from "react";

// Importing the useEffect hook.
import { useEffect } from "react";

// Importing the Bootstrap Button, Form, and Modal components.
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";

// Importing the APIService file.
import APIService from "../APIService";

// UpdateYearAndMajorForm Component: Displays a popup requesting the student's year and major.
function UpdateYearAndMajorForm({forceOpen, onClose}) {
    // State of the year and major fields.
    const [year, setYear] = useState("");
    const [major, setMajor] = useState("");

    // Function to update the student's year and major in the database when the 
    // user clicks Submit.
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = { year, major };
        await APIService.InsertStudentData(formData);
        onClose();
        window.location.reload();  // Force refresh the page.
    };

    // Set the initial state of the modal to closed.
    const [openModal, setOpenModal] = useState(false);
    
    // Function to close the modal.
    const closeModal = () => {
        setOpenModal(false);
        onClose();  // Notify parent to close the modal.
    };

    // Function to force the modal open.
    useEffect(() => {
        // Override modal visibility if forceOpen is true.
        if (forceOpen) {
            setOpenModal(true);
        }
    }, [forceOpen]);

    return (
        <>
            <Modal
                className="login-form-modal"
                show={openModal}
                onHide={closeModal}
            >
                <Modal.Body>
                    <h4>Please select your year and major.</h4>
                    <br />
                    <Form onSubmit={handleSubmit}>
                        <Form.Select
                            value={year}
                            aria-describedby="year"
                            onChange={(e) => setYear(e.target.value)}
                        >
                            <option selected>Please select your year...</option>
                            <option value="1">First</option>
                            <option value="2">Second</option>
                            <option value="3">Third</option>
                            <option value="4">Fourth</option>
                            <option value="5">Graduate</option>
                        </Form.Select>
                        <Form.Text id="year" muted>
                            Year
                        </Form.Text>
                        <br />
                        <br />
                        <Form.Select
                            value={major}
                            onChange={(e) => setMajor(e.target.value)}
                            aria-describedby="major"
                        >
                            <option selected>Please select your major...</option>
                            <option value="Accountancy">Accountancy</option>
                            <option value="American Studies">American Studies</option>
                            <option value="Anthropology">Anthropology</option>
                            <option value="Applied Biology">Applied Biology</option>
                            <option value="Applied Mathematics">Applied Mathematics</option>
                            <option value="Architecture">Architecture</option>
                            <option value="Art, Studio">Art, Studio</option>
                            <option value="Art and Architecture History">
                                Art and Architecture History
                            </option>
                            <option value="Art Education">Art Education</option>
                            <option value="Arts Management and Arts Entrepreneurship">
                                Arts Management and Arts Entrepreneurship
                            </option>
                            <option value="Athletic Training">Athletic Training</option>
                            <option value="Biochemistry">Biochemistry</option>
                            <option value="Biological Science">Biological Science</option>
                            <option value="Biology">Biology</option>
                            <option value="Biomedical Engineering">
                                Biomedical Engineering
                            </option>
                            <option value="Biomedical Science">Biomedical Science</option>
                            <option value="Botany">Botany</option>
                            <option value="Business Administration">
                                Business Administration
                            </option>
                            <option value="Business Analytics">Business Analytics</option>
                            <option value="Business Economics">Business Economics</option>
                            <option value="Cell, Molecular and Structural Biology">
                                Cell, Molecular and Structural Biology
                            </option>
                            <option value="Chemical and Biomedical Engineering">
                                Chemical and Biomedical Engineering
                            </option>
                            <option value="Chemical Engineering">Chemical Engineering</option>
                            <option value="Chemistry">Chemistry</option>
                            <option value="Chinese Education">Chinese Education</option>
                            <option value="Classical Studies">Classical Studies</option>
                            <option value="Clinical Engineering">Clinical Engineering</option>
                            <option value="Communication Design">Communication Design</option>
                            <option value="Communication Studies">
                                Communication Studies
                            </option>
                            <option value="Community Arts and Cultures">
                                Community Arts and Cultures
                            </option>
                            <option value="Computer Engineering">Computer Engineering</option>
                            <option value="Computer Science">Computer Science</option>
                            <option value="Criminal Justice">Criminal Justice</option>
                            <option value="Critical Race and Ethnic Studies">
                                Critical Race and Ethnic Studies
                            </option>
                            <option value="Curriculum and Instruction">
                                Curriculum and Instruction
                            </option>
                            <option value="Cybersecurity">Cybersecurity</option>
                            <option value="Cybersecurity & Networking">
                                Cybersecurity & Networking
                            </option>
                            <option value="Data Analytics">Data Analytics</option>
                            <option value="Data Science and Statistics">
                                Data Science and Statistics
                            </option>
                            <option value="Digital Commerce">Digital Commerce</option>
                            <option value="Diplomacy and Global Politics">
                                Diplomacy and Global Politics
                            </option>
                            <option value="East Asian Language and Cultures">
                                East Asian Language and Cultures
                            </option>
                            <option value="Ecology, Evolution and Environmental Biology">
                                Ecology, Evolution and Environmental Biology
                            </option>
                            <option value="Economics">Economics</option>
                            <option value="Educational Leadership">
                                Educational Leadership
                            </option>
                            <option value="Electrical and Computer Engineering">
                                Electrical and Computer Engineering
                            </option>
                            <option value="Electrical Engineering">
                                Electrical Engineering
                            </option>
                            <option value="Emerging Technology in Business & Design">
                                Emerging Technology in Business & Design
                            </option>
                            <option value="Engineering Management">
                                Engineering Management
                            </option>
                            <option value="Engineering Technology">
                                Engineering Technology
                            </option>
                            <option value="English">English</option>
                            <option value="English/Creative Writing">
                                English/Creative Writing
                            </option>
                            <option value="English/Literature">English/Literature</option>
                            <option value="English Studies">English Studies</option>
                            <option value="Entrepreneurship and Emerging Technology">
                                Entrepreneurship and Emerging Technology
                            </option>
                            <option value="Environmental Earth Science">
                                Environmental Earth Science
                            </option>
                            <option value="Environmental Science">
                                Environmental Science
                            </option>
                            <option value="Esports Management">Esports Management</option>
                            <option value="Family Nurse Practitioner">
                                Family Nurse Practitioner
                            </option>
                            <option value="Finance">Finance</option>
                            <option value="Foreign Language Education">
                                Foreign Language Education
                            </option>
                            <option value="French">French</option>
                            <option value="French Education">French Education</option>
                            <option value="Games + Simulation">Games + Simulation</option>
                            <option value="Geography and Sustainable Development">
                                Geography and Sustainable Development
                            </option>
                            <option value="Geology">Geology</option>
                            <option value="German">German</option>
                            <option value="German Education">German Education</option>
                            <option value="Gerontological Studies">
                                Gerontological Studies
                            </option>
                            <option value="History">History</option>
                            <option value="Hospitality Management">
                                Hospitality Management
                            </option>
                            <option value="Human Capital Management and Leadership">
                                Human Capital Management and Leadership
                            </option>
                            <option value="Individualized Studies">
                                Individualized Studies
                            </option>
                            <option value="Information Systems and Cybersecurity Management">
                                Information Systems and Cybersecurity Management
                            </option>
                            <option value="Information Technology">
                                Information Technology
                            </option>
                            <option value="Integrated English Language Arts Education">
                                Integrated English Language Arts Education
                            </option>
                            <option value="Integrated Mathematics Education">
                                Integrated Mathematics Education
                            </option>
                            <option value="Integrated Science Education">
                                Integrated Science Education
                            </option>
                            <option value="Integrated Social Studies Education">
                                Integrated Social Studies Education
                            </option>
                            <option value="Integrative Studies">Integrative Studies</option>
                            <option value="Interior Design">Interior Design</option>
                            <option value="International Studies">
                                International Studies
                            </option>
                            <option value="Italian Studies">Italian Studies</option>
                            <option value="Journalism">Journalism</option>
                            <option value="Kinesiology">Kinesiology</option>
                            <option value="Kinesiology, Nutrition, and Health">
                                Kinesiology, Nutrition, and Health
                            </option>
                            <option value="Latin American Latino/a and Caribbean Studies">
                                Latin American Latino/a and Caribbean Studies
                            </option>
                            <option value="Latin Education">Latin Education</option>
                            <option value="Learning Sciences and Human Development">
                                Learning Sciences and Human Development
                            </option>
                            <option value="Learning Technologies">
                                Learning Technologies
                            </option>
                            <option value="Liberal Studies">Liberal Studies</option>
                            <option value="Linguistics">Linguistics</option>
                            <option value="Literacy and Language">
                                Literacy and Language
                            </option>
                            <option value="Management">Management</option>
                            <option value="Marketing">Marketing</option>
                            <option value="Mathematics">Mathematics</option>
                            <option value="Mathematics and Statistics">
                                Mathematics and Statistics
                            </option>
                            <option value="Mechanical and Smart Manufacturing Engineering">
                                Mechanical and Smart Manufacturing Engineering
                            </option>
                            <option value="Mechanical Engineering">
                                Mechanical Engineering
                            </option>
                            <option value="Media and Communication">
                                Media and Communication
                            </option>
                            <option value="Medical Laboratory Science">
                                Medical Laboratory Science
                            </option>
                            <option value="Microbiology">Microbiology</option>
                            <option value="Middle Childhood Education">
                                Middle Childhood Education
                            </option>
                            <option value="Music">Music</option>
                            <option value="Music Composition">Music Composition</option>
                            <option value="Music Education">Music Education</option>
                            <option value="Music Performance">Music Performance</option>
                            <option value="Nurse Executive Leadership">
                                Nurse Executive Leadership
                            </option>
                            <option value="Nursing">Nursing</option>
                            <option value="Nursing Practice">Nursing Practice</option>
                            <option value="Nutrition">Nutrition</option>
                            <option value="Organizational Leadership">
                                Organizational Leadership
                            </option>
                            <option value="Philosophy">Philosophy</option>
                            <option value="Physician Associate Studies">
                                Physician Associate Studies
                            </option>
                            <option value="Physics">Physics</option>
                            <option value="Political Scienc">Political Science</option>
                            <option value="Primary Education PK-5">
                                Primary Education PK-5
                            </option>
                            <option value="Professional Writing">Professional Writing</option>
                            <option value="Psychological Science">
                                Psychological Science
                            </option>
                            <option value="Psychology">Psychology</option>
                            <option value="Public Administration">
                                Public Administration
                            </option>
                            <option value="Public Health">Public Health</option>
                            <option value="Quantitative Economics">
                                Quantitative Economics
                            </option>
                            <option value="Real Estate">Real Estate</option>
                            <option value="Robotics Engineering">Robotics Engineering</option>
                            <option value="Russian, Eastern European, and Eurasian Studies">
                                Russian, Eastern European, and Eurasian Studies
                            </option>
                            <option value="Sales Management">Sales Management</option>
                            <option value="School Leadership">School Leadership</option>
                            <option value="School Psychology">School Psychology</option>
                            <option value="Science Education">Science Education</option>
                            <option value="Small Business Management">
                                Small Business Management
                            </option>
                            <option value="Smart Manufacturing Engineering">
                                Smart Manufacturing Engineering
                            </option>
                            <option value="Social Gerontology">Social Gerontology</option>
                            <option value="Social Justice">Social Justice</option>
                            <option value="Social Work">Social Work</option>
                            <option value="Sociology">Sociology</option>
                            <option value="Software Engineering">Software Engineering</option>
                            <option value="Spanish">Spanish</option>
                            <option value="Spanish Education">Spanish Education</option>
                            <option value="Special Education">Special Education</option>
                            <option value="Speech-Language Pathology">
                                Speech-Language Pathology
                            </option>
                            <option value="Speech Pathology and Audiology">
                                Speech Pathology and Audiology
                            </option>
                            <option value="Sport Analytics">Sport Analytics</option>
                            <option value="Sport Coaching">Sport Coaching</option>
                            <option value="Sport Communication and Media">
                                Sport Communication and Media
                            </option>
                            <option value="Sport Leadership and Management">
                                Sport Leadership and Management
                            </option>
                            <option value="Sport Management">Sport Management</option>
                            <option value="Statistics">Statistics</option>
                            <option value="Strategic Communication">
                                Strategic Communication
                            </option>
                            <option value="Supply Chain and Operations Management">
                                Supply Chain and Operations Management
                            </option>
                            <option value="Student Affairs in Higher Education">
                                Student Affairs in Higher Education
                            </option>
                            <option value="Theatre">Theatre</option>
                            <option value="Urban and Regional Planning">
                                Urban and Regional Planning
                            </option>
                            <option value="Women's, Gender, and Sexuality Studies">
                                Women's, Gender, and Sexuality Studies
                            </option>
                            <option value="Zoology">Zoology</option>
                            <option value="Other">Other</option>
                        </Form.Select>
                        <Form.Text id="major" muted>
                            Major
                        </Form.Text>
                        <br />
                        <br />
                        <div className="text-center">
                            <Button
                                type="submit"
                                className="btn-lg login-form-button"
                                onClick={closeModal}
                            >
                                Submit
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}

// Exporting the UpdateYearAndMajorForm component so it can be imported and
// used in other parts of the app.
export default UpdateYearAndMajorForm;
